<template>
  <div class="d-inline-block">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          icon
          v-bind="attrs"
          v-on="on"
          @click="goToCreatePage"
        >
          <v-icon>mdi-plus-box-outline</v-icon>
        </v-btn>
      </template>
      <span>Create Otso Panalo Game</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    goToCreatePage() {
      this.$router.push({ name: "OtsoPanaloCreateGame" });
    },
  },
};
</script>
